/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { DtmDocCreateRequest } from '../types/DtmDocCreate';
import type { DtmDocCreateResponse } from '../types/DtmDocCreate';

export type DtmDocsCreateRequest = DtmDocCreateRequest;
export type DtmDocsCreateResponse = DtmDocCreateResponse;

export type DtmDocsCreateQuery = {};

/**
 * POST /dmx-server/dtm_docs/
 *
 * ```yaml
 * operationId: dtm_docs_create
 * tags:
 *   - dtm_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmDocCreate'
 *     description: ''
 * ```
 */
export const dtmDocsCreateOperation = (rest?: DtmDocsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/dtm_docs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/dtm_docs/' };
  };

/**
 * POST /dmx-server/dtm_docs/
 *
 * ```yaml
 * operationId: dtm_docs_create
 * tags:
 *   - dtm_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/DtmDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/DtmDocCreate'
 *     description: ''
 * ```
 */
export const dtmDocsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: DtmDocsCreateQuery;
  request: DtmDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<DtmDocCreateResponse>> => {
  const operation = dtmDocsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
